import { EventDispatcher, UpdateOverlayActions, OverlayIds, UpdateOverlayOptions, GenericActions } from '.';

export const remoteLoginEvent = () => {
    return (options?: UpdateOverlayOptions) => {
        const eventDispatcher = EventDispatcher();
        eventDispatcher.updateOverlay(UpdateOverlayActions.SHOW, OverlayIds.LOGIN_AND_REGISTER, options);
    };
};

export const remoteUpateCartEvent = () => {
    return (shouldShowCartFlyout: boolean) => {
        const eventDispatcher = EventDispatcher();
        eventDispatcher.updateCart(GenericActions.REFRESH, shouldShowCartFlyout);
    };
};

export default remoteLoginEvent;
